import Enhancer from './enhancer.js';

class EnhancerApp {

    enhancers = {};
    instances = {};

    constructor() {
        
    }

    initEnhancer(enhancerName, enhancerElement) {

        const enhancerType = this.enhancers[enhancerName];

        if (!enhancerType) {
            if (window.console && typeof console.error === "function") {
                console.error("Non-existing enhancer: '%s' on %o", enhancerName, enhancerElement);
            }
        }
       
        const enhancerInstance = new enhancerType(enhancerElement, this);
        enhancerInstance.init();
        enhancerInstance.element.isEnhanced = true;

        if (this.instances[enhancerElement] === undefined) {
            this.instances[enhancerElement] = [];
        }

        this.instances[enhancerElement].push(enhancerInstance);
        
    }

    initEnhancers(context = document) {

        const enhancedElements = context.querySelectorAll("[data-enhancer]");

        enhancedElements.forEach((enhancerElement) => {
            const enhancerNames = enhancerElement.getAttribute("data-enhancer").split(' ');

            enhancerNames.forEach((enhancerName) => {
                this.initEnhancer(enhancerName, enhancerElement);
            });
        });
    }

    start() {
        this.initEnhancers();
    }

    register(name, enhancerClass) {
        this.enhancers[name] = enhancerClass;
    }

    getEnhancerForElement(element, enhancerName) {
        const enhancerType = this.enhancers[enhancerName];

        if (!enhancerType) {
            console.error("Cannot get enhancer with name: " + enhancerName);
        }

        return this.instances[element].find(object => object instanceof enhancerType);
    }
};

export default new EnhancerApp();